import { JSX } from "preact/jsx-runtime";
import { AvatarSelector } from "../../components/AvatarSelector";
import { GameLimits } from "../../components/GameLimits";
import {
  MyBetInner,
  GameRules,
  MyBets,
  Onboarding,
  ProvablyFair,
  ProvablyFairDescription,
  Language,
  Skins,
} from "../../pages";
import { useModal, ModalType } from "../../shared/contexts";
import { Modal } from "../../shared/ui";
import { ReloadModal } from "../ReloadModal";

const renderModalContent = (
  type: ModalType | null,
  data: any,
  onClose: () => void
): JSX.Element | null => {
  switch (type) {
    case "myBets":
      return <MyBets />;
    case "myBetDetails":
      return <MyBetInner roundId={Number(data ?? 0)} />;
    case "provablyFair":
      return <ProvablyFair />;
    case "gameRules":
      return <GameRules />;
    case "onboarding":
      return <Onboarding onClose={onClose} />;
    case "ProvablyFairDescription":
      return <ProvablyFairDescription />;
    case "language":
      return <Language />;
    case "avatarSelector":
      return <AvatarSelector />;
    case "gameLimits":
      return <GameLimits />;
    case "reloadModal":
      return <ReloadModal />;
    case "skins":
      return <Skins />;
    default:
      return null;
  }
};

export const ModalManager = () => {
  const { modalStack, closeModal } = useModal();

  const isFullScreenModals = modalStack.some((m) => m.type === "reloadModal");
  return (
    <>
      {modalStack.map((m, idx) => (
        <Modal
          key={idx}
          isOpen={true}
          onClose={closeModal}
          zIndex={9999 + idx}
          fullScreen={isFullScreenModals}
        >
          {renderModalContent(m.type, m.data, closeModal)}
        </Modal>
      ))}
    </>
  );
};
